import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  reduxForm,
  Form,
  InjectedFormProps,
  getFormValues,
  touch,
  isValid,
  reset
} from 'redux-form';

import { BatteryFormData, validate } from '../components/formData/BatteryFormData';
import { renderField } from '../helpers/renderHelper';
import { productChoiceStepField } from '../fields/customer/productChoiceField';
import { installationStepField } from '../fields/customer/installationField';
import { quoteSummaryField } from '../fields/customer/quoteSummaryField';
import PeThankyouPage from '../components/PeThankyouPage';

import State from '../states/State';
import PeButton from '../components/PeButton';
import { Grid } from '@material-ui/core';

import slice from '../states/shell/slice';
import useStyles from '../styles/styles';

import { installationStepField as installationStepFieldMaster } from '../fields/master/installationField';
import { productChoiceStepField as productChoiceStepFieldMaster } from '../fields/master/productChoiceField';
import { quoteSummaryField as quoteSummaryFieldMaster } from '../fields/master/quoteSummaryField';

import PeRecaptcha from '../components/PeRecaptcha';
import ReCAPTCHA from 'react-google-recaptcha';

const formName = 'battery-form';

type BatteryFormProps = {
  readonly shellState?: any,
  readonly formValues?: any,
  readonly startAsyncValidation?: any,
  readonly isValid?: any,
}

const BatteryForm: React.FC<InjectedFormProps<BatteryFormData, BatteryFormProps> & BatteryFormProps> = (props) => {
  const classes = useStyles();
  const { handleSubmit, formValues } = props;
  const state = useSelector((state: State) => {
    const shell = state.shell
    return ({
      shell
    });
  });
  const { currentStep, steps } = state.shell?.step;
  const dispatch = useDispatch();
  const isAuth = state.shell?.isAuth;

  const recaptchaRef = React.createRef<ReCAPTCHA>();
  const [recaptcha, setRecaptcha] = React.useState(isAuth);

  React.useEffect(() => {
    if (recaptchaRef.current) {
      const recaptchaValue = recaptchaRef.current.getValue();
      if (!recaptchaValue) {
        setRecaptcha(false);
      }
    }
    return;
  }, [recaptchaRef]);

  const handleStepOver = () => {
    // Reset Step
    dispatch(slice.actions.updateCurrentStep(1));
    dispatch(slice.actions.updateDoneStep(0));
    // Reset form value
    dispatch(reset(formName));
  }

  return <Form onSubmit={handleSubmit}>
    <section id="myForm" style={{position: 'relative'}}>
      {currentStep === steps.length ? <PeThankyouPage /> :
        steps && steps.map((stepItem: any) => {
          switch (stepItem.id) {
            case 1:
              return <section key={"step-" + stepItem.id} id={"step-" + stepItem.id}>
                {renderField(state.shell?.isAuth ? installationStepFieldMaster : installationStepField, formValues, state.shell?.isAuth)}
              </section>
            case 2:
              return <section key={"step-" + stepItem.id} id={"step-" + stepItem.id}>
                {renderField(state.shell?.isAuth ? productChoiceStepFieldMaster : productChoiceStepField, formValues, state.shell?.isAuth)}
              </section>
            case 3:
              return <section key={"step-" + stepItem.id} id={"step-" + stepItem.id}>
                {renderField(state.shell?.isAuth ? quoteSummaryFieldMaster : quoteSummaryField, formValues, state.shell?.isAuth)}
              </section>
            default: return false;
          }
        })
      }
    </section>

    {(props.isValid && !isAuth && currentStep === steps.length - 1) && <PeRecaptcha ref={recaptchaRef}
      onExpired={() => setRecaptcha(false)}
      onChange={(value: any) => {
        value && setRecaptcha(true);
        return;
      }}
    />}
    
    {(props.isValid && currentStep === steps.length - 1) 
      && <div id="node_pebutton" className={classes.SandenForm_control}>
      <Grid container spacing={2} className={classes.SandenForm_button}>
        <Grid item xs={6} sm={6} md={3}>
          <PeButton label="Start Over?" type="button" onClick={handleStepOver}/>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <PeButton label="Submit Quote" type="submit" />
        </Grid>
      </Grid>
    </div>}
  </Form>
}

// create form
const BatteryFormState = reduxForm<BatteryFormData, BatteryFormProps>({
  form: 'battery-form',
  enableReinitialize: true,
})(BatteryForm);

const mapStateToProps = (state: any) => {
  return {
    shellState: state.shell,
    formValues: getFormValues(formName)(state),
    isValid: isValid(formName)(state),
    validate: validate,
    initialValues: state.shell.initialValues,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    startAsyncValidation: () => dispatch(touch('battery-form')),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BatteryFormState);